import { render, staticRenderFns } from "./SettingsApiView.vue?vue&type=template&id=46da7d28&"
import script from "./SettingsApiView.vue?vue&type=script&lang=ts&"
export * from "./SettingsApiView.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsApiView.vue?vue&type=style&index=0&id=46da7d28&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports